var url = `https://printworks.coi-agency.services`;

class PhotoQuantity {
  constructor(element) {
    this.element = element;
    this.variantMap = new Map();



    // Initialize the variant map from all inputs with name="id" 
    this.inputs = this.element.querySelectorAll('.photo__variant__input');
    this.resetMap(); // Initialize the map with existing inputs



    localStorage.removeItem('upload_token'); // Clear the upload token on initialization
    localStorage.removeItem('upload_timestamp'); // Clear the upload timestamp on initialization
    localStorage.removeItem('security_token'); // Clear the security token on initialization
  }

  resetMap() {
    this.variantMap.clear(); // Clear the existing map
    this.inputs.forEach(input => {
      const variantId = input.dataset.id;
      const title = input.dataset.name; // data-name holds the title
      const price = input.dataset.price; // data-name holds the title
      const quantity = parseInt(input.dataset.quantity) || 0;
      this.variantMap.set(variantId, { variantId, title, quantity, price });
    });
  }

  resetAllInputs() {
    this.inputs.forEach(input => {
      input.dataset.quantity = 0;
    });
    this.resetMap(); // Reset the map to reflect the cleared inputs
  }

  updateQuantity(direction, id, old_id, quantity_change = 1) {
    if (direction === 'increase') {
      const input = this.element.querySelector(`#id__${id}`);
      if (input) {
        const newQuantity = parseInt(input.dataset.quantity) + quantity_change;
        input.dataset.quantity = newQuantity;
        // Update the map as well
        this.updateMapQ(id, newQuantity);
      }
    } else if (direction === 'decrease') {
      const input = this.element.querySelector(`#id__${id}`);
      if (input) {
        const newQuantity = parseInt(input.dataset.quantity) - quantity_change;
        input.dataset.quantity = newQuantity;
        this.updateMapQ(id, newQuantity);
      }
    } else if (direction === 'change') {
      const input = this.element.querySelector(`#id__${id}`);
      const oldInput = this.element.querySelector(`#id__${old_id}`);
      if (input && oldInput) {
        const newQuantity = parseInt(input.dataset.quantity) + quantity_change;
        const oldNewQuantity = parseInt(oldInput.dataset.quantity) - quantity_change;
        input.dataset.quantity = newQuantity;
        oldInput.dataset.quantity = oldNewQuantity;
        this.updateMapQ(id, newQuantity);
        this.updateMapQ(old_id, oldNewQuantity);
      }
    }
  }


  updateQuantityAll(direction) {
    const allCards = this.element.querySelectorAll(".photo-print__card-wrapper");
    const variantCounts = {};


    if (direction === 'increase') {
      // Old behavior: count selected images
      allCards.forEach(card => {
        const variant = card.dataset.variant;
        const quantityInput = card.querySelector('input[name="quantity"]');
        let currentQty = parseInt(quantityInput.value) || 1;
        if (variant) {
          variantCounts[variant] = (variantCounts[variant] || 0) + currentQty;
        }
      });

      for (const variant in variantCounts) {
        const count = variantCounts[variant];
        const input = this.element.querySelector(`#id__${variant}`);
        if (input) {
          input.dataset.quantity = count;
          this.updateMapQ(variant, count);
        }
      }

    } else if (direction === 'decrease') {
      // Old behavior: reset all to zero
      this.inputs.forEach(input => {
        input.dataset.quantity = 0;
        const variant = input.dataset.id;
        this.updateMapQ(variant, 0);
      });


    }
  }



  updateMapQ(id, quantity) {
    const variantData = this.variantMap.get(id);
    if (variantData) {
      variantData.quantity = quantity;
      this.variantMap.set(id, variantData);
    }
    this.printVariantInfo(); // Call the method to print out variant information
  }

  printVariantInfo() {
    const outputContainer = this.element.querySelector('#images_total');
    if (!outputContainer) return;

    let first = true;
    let totalPrice = 0;
    outputContainer.innerHTML = ''; // Clear existing content

    // Loop over each variant in variantMap
    this.variantMap.forEach(info => {
      if (info.quantity === 0) return; // Only display if quantity > 0

      // Convert price to a number and add to total
      const numericPrice = parseFloat(info.price);
      totalPrice += numericPrice * info.quantity;

      const span = document.createElement('span');
      span.classList.add('u-t3');
      const price = Shopify.formatMoney(info.price, window.theme.moneyFormat);

      // Use a separator if more than one info is appended.
      span.textContent = !first
        ? ` | ${info.title} - ${price} x ${info.quantity} pc`
        : `${info.title} - ${price} x ${info.quantity} pc`;

      first = false;
      outputContainer.appendChild(span);
    });

    // If no variant has a quantity above zero, clear the container and disable ATC
    if (totalPrice === 0) {
      outputContainer.innerHTML = '';
      document.querySelectorAll('.product-module__product-atc').forEach(el => {
        el.setAttribute('disabled', 'true');
      });
      // Optionally, clear any displayed total price in the footer.
      document.querySelectorAll('.pp__upload-footer .product-module__atc-price').forEach(el => {
        el.innerHTML = '';
      });
      return;
    } else {
      document.querySelectorAll('.product-module__product-atc').forEach(el => {
        el.removeAttribute('disabled');
      });
    }

    // Append total price to the relevant elements.
    const totalFormattedPrice = Shopify.formatMoney(totalPrice, window.theme.moneyFormat);
    document.querySelectorAll('.pp__upload-footer .product-module__atc-price').forEach(el => {
      el.innerHTML = `|&nbsp;${totalFormattedPrice}`;
    });
  }

}



class PhotoPrinting extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.photoQuantity = new PhotoQuantity(this);
    this.uploadedFiles = 0; // Reset uploaded files count
  }

  connectedCallback() {

    this.init();
    this.checkLoaded();
    this.bindEvents();

  }

  init() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);



    this.photoPrinterStartContent = this.element.querySelector(".photo-printer__content");
    this.imgCardTemplate = this.element.querySelector('#photo-print__card-template');

    this.deleteBtn = this.element.querySelector('.pp__header-remove-btn');
    this.uploadOverlay = this.element.querySelector('.pp__overlay');

    this.itemsToDelete = this.element.querySelector('.pp__delete-count');
    this.itemsToATC = this.element.querySelector('.atc-selected-count');

    this.editPopUp = this.element.querySelector('.fabric-js__popup');

    this.updateFooterHeight();

  }

  updateFooterHeight() {
    const uploadFooterHeight = this.element.querySelector('.pp__upload-footer')?.offsetHeight;
    if (uploadFooterHeight !== undefined) {
      document.documentElement.style.setProperty('--upload-footer-height', `${uploadFooterHeight}px`);
    }
  }
  checkLoaded() {
    var _this = this;


    if (typeof Uppy !== "undefined") {

      this.uppyInit();

    } else {
      loadScript(window.theme.uppyScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }


  }

  async resetUploadToken() {
    const token = localStorage.getItem("upload_token");

    if (!token) {
      console.warn("No upload token found. Skipping deletion.");
      return;
    }

    try {
      // Attempt to delete all files associated with this token
      await apiService.deleteFiles(token, '/api/file/token-delete');

      // Clear localStorage after successful deletion
      localStorage.removeItem("upload_token");


    } catch (error) {
      console.error("Error deleting files before resetting token:", error);
    }
  }


  uppyInit() {
    const companionUrl = 'https://companion.uppy.io';
    const container = this.element.querySelector('.container');
    this.maxFileSize = 50 * 1024 * 1024;

    // Initialize Uppy
    this.uppy = new Uppy.Uppy({
      debug: true,
      autoProceed: false,
      restrictions: {
        allowedFileTypes: [
          'image/jpeg', // covers both .jpeg and .jpg
          'image/png',
          'image/heic',
          'image/heif',
          'image/webp'
        ]
      }
    });


    // Use plugins
    this.uppy
      .use(Uppy.FileInput, {
        target: document.body,
        pretty: false
      })
      .use(Uppy.ThumbnailGenerator, {
        thumbnailWidth: 200,
        waitForThumbnailsBeforeUpload: false
      })
      .use(Uppy.Dropbox, { companionUrl })
      .use(Uppy.Instagram, { companionUrl })
      .use(Uppy.DragDrop, { target: '#file-list--1', id: 'DragDrop1' })
      .use(Uppy.DragDrop, { target: '#file-list--2', id: 'DragDrop2' })
      .use(Uppy.XHRUpload, {
        endpoint: `${url}/api/upload`,
        headers: {},
        credentials: 'include',
        fieldName: 'file'
      });

    // Cache FileInput plugin for later
    this.fileInputPlugin = this.uppy.getPlugin('FileInput');

    // Log loaded plugins
    this.uppy.iteratePlugins(plugin => {
      console.log(plugin.id, 'heree');
    });

    // Dropbox button
    document.getElementById("select-dropbox")?.addEventListener("click", () => {
      const dropbox = this.uppy.getPlugin('Dropbox');
      if (dropbox) dropbox.openModal();
    });

    // Google Drive button
    document.getElementById("select-google")?.addEventListener("click", () => {
      this.uppy.use(Uppy.GoogleDrivePicker, {
        companionUrl,
        target: container
      });
    });

    // Instagram button
    document.getElementById("select-instagram")?.addEventListener("click", () => {
      const instagram = this.uppy.getPlugin("Instagram");
      if (instagram) instagram.openModal();
    });

    // File added event
    this.uppy.on("file-added", async (file) => {
      await this.uploadFiles(file);
    });


    // Thumbnail generation
    this.uppy.on('thumbnail:generated', (file, preview) => {
      const card = this.element.querySelector(`[data-file-uppy-id="${file.id}"]`);
      const imgElement = card?.querySelector(".photo-print__card-image");
      if (imgElement) {
        imgElement.src = preview;
      }
    });

    this.bindEventsUppy();
  }

  async uploadFiles(file) {
    // Check the file size
    if (file.size > this.maxFileSize) {
      const err_msg = window.photoPrinterStrings.errMsgLimit;
      this.showErrorPopup(err_msg, true);
      // Remove the file from Uppy’s list to avoid further processing
      this.uppy.removeFile(file.id);
      return;
    }

    // Display the selected file preview/UI
    this.displaySelectedFile(file);

    // If tokens haven't been set, call setTokens() and cache the promise so it doesn't run concurrently
    if (!this.tokenPromise) {
      this.tokenPromise = this.setTokens();
    }

    // Await token set up before proceeding with the upload
    await this.tokenPromise;
    await this.handleFileUpload();

    // Reset tokenPromise to allow new token acquisition on subsequent uploads if necessary
    this.tokenPromise = null;
  }


  bindEvents() {



    this.delegateElement.on(
      "click",
      '#select-device',
      this.triggerFileInputClick.bind(this)
    );
    this.delegateElement.on('click', '[data-action="upload-again-err"]', this.uploadAgain.bind(this));

    this.delegateElement.on(
      "click",
      '[data-action="toggle-checkbox"]',
      this.toggleCheckboxForImg.bind(this)
    );

    this.delegateElement.on(
      "click",
      "#select-all-imgs",
      this.toggleSelectAll.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="delete-selected-imgs"]',
      this.handleDeleteMethod.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="remove-item"]',
      this.handleDeleteMethod.bind(this)
    )

    this.delegateElement.on(
      "click",
      '[data-action="edit-img"]',
      this.editImgHandle.bind(this)
    );


    this.delegateElement.on(
      "click",
      '[data-action="quantity-decrease"]',
      this.itemQuantityDec.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="quantity-increase"]',
      this.itemQuantityInc.bind(this)
    );

    this.delegateElement.on(
      'change',
      'input[name="quantity"]',
      this.itemQuantityInputChange.bind(this)
    );

    this.delegateElement.on(
      'update:main-atc',
      this.handleVariantChange.bind(this)
    );

    this.delegateElement.on('click', '[data-action="exit-intent"]', this.exitIntent.bind(this));

  }

  bindEventsUppy() {

    function handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
    }

    this.delegateBody.on("reset:reset-upload", () => {
      this.goBackToStart();           // Existing reset behavior
    });

    window.globalPopup.onPopupOpen = function (popupElement) {
      if (popupElement.id === 'modal-upload-photos') {
        //   window.addEventListener('beforeunload', handleBeforeUnload);
      }
    };

    window.globalPopup.onPopupClose = function (popupElement) {
      if (popupElement.id === 'modal-upload-photos') {
        //    window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    };



    this.uppy.on("upload-progress", this.updateUploadProgress.bind(this));
    this.uppy.on("upload-success", this.handleUploadSuccess.bind(this));
  }

  // Then add this new method to your PhotoPrinting class:
  itemQuantityInputChange(event) {
    const input = event.target;
    // Parse and ensure a minimum value of 1
    let newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 1) {
      newQty = 1;
      input.value = newQty;
    }

    // Get the image card (container) that holds the input and its variant data
    const card = input.closest('.photo-print__card-wrapper');
    if (!card) return;
    const variantId = card.dataset.variant;

    // Recalculate the total quantity for this variant by summing quantities from all cards with the same variant
    let totalQuantity = 0;
    const cardsForVariant = this.element.querySelectorAll(
      `.photo-print__card-wrapper[data-variant="${variantId}"]`
    );
    cardsForVariant.forEach(c => {
      const qtyInput = c.querySelector('input[name="quantity"]');
      totalQuantity += parseInt(qtyInput.value, 10) || 0;
    });

    // Update the hidden input that holds the overall quantity for this variant (if such an input exists)
    const hiddenInput = this.element.querySelector(`#id__${variantId}`);
    if (hiddenInput) {
      hiddenInput.dataset.quantity = totalQuantity;
    }

    // Update the variantMap with the new total quantity.
    this.photoQuantity.updateMapQ(variantId, totalQuantity);

    // Optionally update the metadata for the current image
    const fileServerId = card.dataset.fileServerId;
    if (fileServerId) {
      this.updateMetadataQuantity(fileServerId, newQty);
    }
  }

  uploadAgain(event) {

    const popup = event.target.closest('#modal-pp-error');

    if (popup) {
      window.globalPopup.closePopup(popup);
    }

    if (this.uploadOverlay?.classList.contains('is-visible')) {
      this.uploadOverlay.classList.remove('is-visible');
    }

    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-upload-photos');
    }
    this.goBackToStart();
  }

  async setTokens() {
    try {
      this.securityToken = localStorage.getItem("security_token");
      this.timestamp = localStorage.getItem("upload_timestamp");
      this.uploadToken = localStorage.getItem("upload_token");

      if (!this.securityToken || !this.timestamp) {

        const response = await apiService.getUploadToken('both');
        this.securityToken = response.securityToken;
        this.timestamp = response.timestamp;
        this.uploadToken = response.uploadToken;

        localStorage.setItem("security_token", this.securityToken);
        localStorage.setItem("upload_timestamp", this.timestamp);
        localStorage.setItem("upload_token", this.uploadToken);
        return true;
      } else if (!this.uploadToken) {

        const response = await apiService.getUploadToken('upload');
        this.uploadToken = response.uploadToken;

        localStorage.setItem("upload_token", this.uploadToken);
        return true;
      } else {

        return true;
      }
    } catch (error) {
      console.error("Error fetching tokens:", error);
      return false;
    }
  }


  async exitIntent() {
    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-upload-photos');
    }

    const token = localStorage.getItem("upload_token");
    if (token) {
      apiService.deleteFiles(token, '/api/file/token-delete')
        .then(result => {
        })
        .catch(error => console.error('Error deleting files:', error));
    }

    localStorage.removeItem("upload_token");
    window.globalPopup.closeAllPopups();
    await this.goBackToStart();
  }

  handleVariantChange(event) {
    const { cardId, variantId, variantValue } = event.detail;

    // Find the image card by the uppy ID
    const imgCard = this.element.querySelector(`[data-file-uppy-id="${cardId}"]`);

    if (!imgCard) {
      console.warn(`No image card found with data-file-uppy-id="${cardId}"`);
      return;
    }

    // Update the data-variant attribute
    const oldVariant = imgCard.getAttribute('data-variant');
    imgCard.setAttribute('data-variant', variantId);

    // Update the label text
    const variantLabel = imgCard.querySelector('.photo-print__card-variant-lbl');
    if (variantLabel) {
      variantLabel.textContent = variantValue;
    } else {
      console.warn('Variant label element not found in image card');
    }

    const quantity = parseInt(imgCard.querySelector('input[name="quantity"]').value) || 1;
    if (variantId == oldVariant) return;
    // 4. Trigger full update of all variant quantities in the form
    this.photoQuantity.updateQuantity('change', variantId, oldVariant, quantity);
  }

  itemQuantityDec(event) {
    const btn = event.target.closest('button');
    const card = btn.closest('.photo-print__card-wrapper');
    if (!card) return;

    const variantId = card.dataset.variant;
    const quantityInput = card.querySelector('input[name="quantity"]');
    let currentQty = parseInt(quantityInput.value) || 1;

    if (currentQty > 1) {
      currentQty--;
      quantityInput.value = currentQty;
      this.updateMetadataQuantity(card.dataset.fileServerId, currentQty);
      // Update hidden input + PhotoQuantity map
      this.photoQuantity.updateQuantity('decrease', variantId, currentQty);
    }

    // Disable the minus button if quantity is 1
    if (currentQty === 1) {
      btn.setAttribute('disabled', '');
    }
  }

  itemQuantityInc(event) {
    const btn = event.target.closest('button');
    const card = btn.closest('.photo-print__card-wrapper');
    if (!card) return;



    // Ensure the minus button is enabled on increase
    const minusBtn = card.querySelector('button[data-action="quantity-decrease"]');
    if (minusBtn) {

      minusBtn.removeAttribute('disabled');
    }

    const variantId = card.dataset.variant;
    const quantityInput = card.querySelector('input[name="quantity"]');
    let currentQty = parseInt(quantityInput.value) || 1;

    currentQty++;
    quantityInput.value = currentQty;
    this.updateMetadataQuantity(card.dataset.fileServerId, currentQty);
    // Update hidden input + PhotoQuantity map
    this.photoQuantity.updateQuantity('increase', variantId, currentQty);
  }

  async updateMetadataQuantity(filename, new_quantity) {
    const updates = { quantity: new_quantity };

    try {
      // Optionally await for metadata update to finish
      const result = await apiService.updateMetadata(filename, updates);
      if (result.error) {
        console.error("Error updating metadata:", result.error, result.details);
      } else {
        console.log("Metadata updated successfully:", result);
      }
    } catch (error) {
      console.error("Error updating metadata:", error);
    }
  }

  async editImgHandle(event) {
    const fileId = event.target.closest('[data-file-server-id]').getAttribute('data-file-server-id');
    const fileUrl = event.target.closest('[data-file-server-id]').getAttribute('data-edit-url');
    const targetButton = event.target;
    const imgCard = event.target.closest('.photo-print__card-wrapper');
    const variantValue = imgCard.querySelector('.photo-print__card-variant-lbl').textContent;
    
    // Get imgCardId from the parent
    const imgCardId = event.target.closest('[data-file-uppy-id]').getAttribute('data-file-uppy-id');

    // Check if the current file ID is already in the popup
    const currentImageUrl = this.editPopUp.getAttribute('data-img-url');

    console.log('variantValue variantValue', variantValue);
    this.initSelectboxVariant(variantValue);
    // If the file ID is the same as the one already in the popup, do nothing
    if (currentImageUrl && currentImageUrl.includes(fileId)) {
      this.element.dispatchEvent(
        new CustomEvent("edit-img:pressed", {
          bubbles: true,
          detail: {
            eventName: "edit-img-btn",
            button: targetButton,
            imgCardId: imgCardId
          },
        })
      );
      return;  // Skip fetching if the same image is already loaded
    }


    const togglePopup = this.element.querySelector('#modal-edit-img');
    const loader = togglePopup.querySelector('.spinningLoader');
    window.globalPopup.openPopup(togglePopup, true);
    loader.classList.add('is-visible');


    // Fetch the original image URL based on the file ID
    await this.fetchOriginalImageUrl(fileId, targetButton, fileUrl, imgCardId);
    loader.classList.remove('is-visible');


  }

  // Function to fetch the original image URL from the server
  async fetchOriginalImageUrl(fileId, targetButton, fileUrl, imgCardId) {
    try {

      const completeUrl = fileUrl;

      // Ensure we have both token and timestamp for security
      if (!this.securityToken || !this.timestamp) {
        throw new Error("Token or timestamp is missing.");
      }


      // Make GET request to fetch the image
      const response = await fetch(completeUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.securityToken}`,
          "Content-Type": "application/json",
          "x-upload-timestamp": this.timestamp,  // Include timestamp for protection
          'ngrok-skip-browser-warning': 'true'

        }
      });

      // Check if the response is successful
      if (!response.ok) {
        throw new Error("Failed to fetch the image.");
      }

      // Get the image as a Blob
      const imageBlob = await response.blob();  // Get the image as a Blob
      const imageUrl = URL.createObjectURL(imageBlob);
      if (imageUrl) {
        // Call the method to save the image URL as an attribute of the popup
        this.saveImageUrlAsPopupAttribute(imageUrl, fileId);

        // Assuming you want to dispatch an event with the image URL
        this.element.dispatchEvent(
          new CustomEvent("edit-img:pressed", {
            bubbles: true,
            detail: {
              eventName: "edit-img-btn",
              button: targetButton,
              imgCardId: imgCardId
            },
          })
        );
      } else {
        throw new Error("Failed to retrieve image URL.");
      }
    } catch (error) {
      console.error("Error fetching the image:", error);
      alert("An error occurred while fetching the image.");
    }
  }

  saveImageUrlAsPopupAttribute(originalImageUrl, fileId) {

    if (this.editPopUp) {
      // Store the image URL as a custom data attribute on the popup
      this.editPopUp.setAttribute('data-img-url', originalImageUrl);
      this.editPopUp.dataset.name = fileId;
    } else {
      console.error('Popup element not found');
    }
  }

  async toggleSelectAll(event) {
    const isChecked = event.target.checked;
    const allCards = this.element.querySelectorAll(".photo-print__card-wrapper");
    event.target.style.pointerEvents = "none"; // Disable pointer events for the checkbox

    allCards.forEach(card => {
      const filledIcon = card.querySelector(".checked-icon.filled");
      const unfilledIcon = card.querySelector(".checked-icon.unfilled");

      if (isChecked) {
        card.setAttribute("aria-selected", "true");
        filledIcon.classList.remove("hidden");
        unfilledIcon.classList.add("hidden");
        this.enableDeleteBtn();

      } else {
        card.setAttribute("aria-selected", "false");
        filledIcon.classList.add("hidden");
        unfilledIcon.classList.remove("hidden");
        this.disableDeleteBtn();

      }
    });

    if (isChecked) {
      this.photoQuantity.updateQuantityAll('increase');
    } else {
      this.photoQuantity.updateQuantityAll('decrease');
    }

    const updates = { updateall: isChecked ? "true" : "false" };

    try {
      // Optionally await for metadata update to finish
      const result = await apiService.updateMetadata(false, updates);
      event.target.style.pointerEvents = "all"; // Disable pointer events for the checkbox
      if (result.error) {
        console.error("Error updating metadata:", result.error, result.details);
      } else {
        console.log("Metadata updated successfully:", result);
      }
    } catch (error) {
      console.error("Error updating metadata:", error);
    }

  }

  enableDeleteBtn() {
    this.deleteBtn.removeAttribute('disabled');
  }

  disableDeleteBtn() {
    this.deleteBtn.setAttribute('disabled', 'true')
  }

  async toggleCheckboxForImg(event) {
    event.preventDefault();
    const cardWrapper = event.target.closest(".photo-print__card-wrapper");
    if (!cardWrapper) return;

    // Destructure useful data from the card wrapper
    const { variant, fileServerId: filename } = cardWrapper.dataset;
    const filledIcon = cardWrapper.querySelector(".checked-icon.filled");
    const unfilledIcon = cardWrapper.querySelector(".checked-icon.unfilled");
    const isSelected = cardWrapper.getAttribute("aria-selected") === "true";

    // Determine new state and corresponding update values
    const newState = !isSelected;
    cardWrapper.setAttribute("aria-selected", newState.toString());
    const quantityInput = cardWrapper.querySelector('input[name="quantity"]');
    const currentQty = parseInt(quantityInput.value) || 1;

    console.log('currentaty', currentQty);
    if (newState) {
      // When selecting the image
      filledIcon.classList.remove("hidden");
      unfilledIcon.classList.add("hidden");
      this.photoQuantity.updateQuantity("increase", variant, null, currentQty);
    } else {
      // When deselecting the image
      unfilledIcon.classList.remove("hidden");
      filledIcon.classList.add("hidden");
      this.photoQuantity.updateQuantity("decrease", variant, null, currentQty);
    }

    // Define the metadata update: adjust included based on new state
    const updates = { included: newState ? "true" : "false" };

    try {
      // Optionally await for metadata update to finish
      const result = await apiService.updateMetadata(filename, updates);
      if (result.error) {
        console.error("Error updating metadata:", result.error, result.details);
      } else {
        console.log("Metadata updated successfully:", result);
      }
    } catch (error) {
      console.error("Error updating metadata:", error);
    }

    // Update "Select All" checkbox based on current selection state of all images
    this.updateSelectAllCheckbox();
  }


  updateSelectAllCheckbox() {
    const allCards = this.element.querySelectorAll(".photo-print__card-wrapper");
    const selectedCards = this.element.querySelectorAll(
      '.photo-print__card-wrapper[aria-selected="true"]'
    );



    const selectAllCheckbox = this.element.querySelector("#select-all-imgs input[type='checkbox']");
    this.itemsToDelete.textContent = selectedCards.length;
    this.itemsToATC.textContent = selectedCards.length;

    // If all images are selected, check "Select All"; otherwise, uncheck it
    selectAllCheckbox.checked = allCards.length === selectedCards.length;

    if (selectedCards.length === 0)
      this.disableDeleteBtn();
    else
      this.enableDeleteBtn();

  }

  async handleDeleteMethod(event) {
    const filenames = this.getFilesToBeDeleted(event);
    const poupToClose = this.element.querySelector('#modal-delete-conf')
    window.globalPopup.closePopup(poupToClose);
    await this.deleteSelectedImgs(filenames);
  }

  getFilesToBeDeleted(event) {
    const eventType = event.target.getAttribute('data-action'); // Identify event type
    if (!eventType) return [];

    if (eventType === "remove-item") {
      const parentElement = event.target.closest("[data-file-server-id]");
      return parentElement ? [parentElement.dataset.fileServerId] : [];
    }

    if (eventType === "delete-selected-imgs") {
      return Array.from(this.element.querySelectorAll(`.photo-print__card-wrapper[aria-selected="true"]`))
        .map(img => img.dataset.fileServerId)
        .filter(Boolean);
    }
    return [];

  }

  async deleteSelectedImgs(filenames) {
    try {

      const response = await fetch(`${url}/api/files/${this.securityToken}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.securityToken}`,
          "Content-Type": "application/json",
          "x-upload-timestamp": this.timestamp
        },
        body: JSON.stringify({ filenames }) // Send filenames as an array
      });

      if (!response.ok) {
        throw new Error("Failed to delete selected files.");
      }

      // Remove deleted files from Uppy
      filenames.forEach(filename => {
        // Find the element with `data-file-server-id` matching the filename
        const element = this.element.querySelector(`[data-file-server-id="${filename}"]`);

        // Extract the corresponding Uppy file ID from `data-file-uppy-id`
        if (element) {
          const uppyFileId = element.getAttribute('data-file-uppy-id');

          // Remove the file from Uppy
          if (uppyFileId) {
            this.uppy.removeFile(uppyFileId);
          }
        }
      });


      //  Call the new `updateUI` function to remove files from the frontend
      this.deletingImgUI(filenames);

    } catch (err) {
      console.error("Error during file deletion:", err);
      alert("An error occurred while deleting the file(s).");
    }
  }


  deletingImgUI(filenames) {
    filenames.forEach((filename) => {
      const parentElement = this.element.querySelector(`[data-file-server-id="${filename}"]`);
      if (parentElement) {
        const variantId = parentElement.dataset.variant; // <--- grab variant ID

        parentElement.classList.add('removing');

        // Wait for the CSS animation to finish before removing the element
        parentElement.addEventListener('transitionend', async () => {
          parentElement.remove();

            // Decrement the uploaded files counter for each deleted file.
        // (Adjust this value only if the file had been already fully uploaded.)
        this.uploadedFiles = Math.max(this.uploadedFiles - 1, 0);

          // ✅ Decrement quantity input and update PhotoQuantity
          const quantityInput = this.element.querySelector(`#id__${variantId}`);
          const cardQuantityInput = parentElement.querySelector('input[name="quantity"]');
          if (quantityInput && cardQuantityInput) {
            const cardQty = parseInt(cardQuantityInput.value) || 1;
            const currentTotal = parseInt(quantityInput.dataset.quantity) || 0;
            const newQty = Math.max(currentTotal - cardQty, 0);

            quantityInput.dataset.quantity = newQty;
            this.photoQuantity.updateMapQ(variantId, newQty);

          }


          // After the element is removed, check if all .photo-print__card-wrapper elements are gone
          const allCards = this.element.querySelectorAll('.photo-print__card-wrapper');
          if (allCards.length === 0) {
            // If no more card wrappers, show .photo-printer__content again and remove .pp__uploaded-content
            await this.goBackToStart();
          } else {
            // **Update the delete all button state and selected count**
            this.updateSelectAllCheckbox();
          }
          // **Update the delete all button state and selected count**
          this.updateSelectAllCheckbox();
          this.updateFooterHeight();
        }, { once: true }); // `once: true` ensures the event listener is automatically removed
      }
    });

    this.updateTotalFilesCount();
  }

  async goBackToStart() {
    const [
      uploadedContent,
      defaultStateFooter,
      uploadStateFooter
    ] = this.element.querySelectorAll(`
        .pp__uploaded-content, 
        .pp__footer-default-state, 
        .pp__footer-uploade-state
      `);

    // Hide uploaded content and clear its grid
    if (uploadedContent) {
      uploadedContent.setAttribute("inert", "");
      const grid = uploadedContent.querySelector('.pp__images-grid');
      if (grid) grid.innerHTML = "";
    }

    // Show start content
    this.photoPrinterStartContent?.removeAttribute("inert");

    // Toggle footers
    defaultStateFooter?.setAttribute('aria-hidden', 'true');
    uploadStateFooter?.setAttribute('aria-hidden', 'false');

    // Reset the aria-controls attribute on the close button back to default ("modal-upload-photos")
    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-upload-photos');
    }



    // Reset Uppy state
    this.uploadedFiles = 0;
    this.uppy.clear();

    this.updateFooterHeight();
    this.photoQuantity.resetAllInputs();
    this.photoQuantity.resetMap();
    await this.resetUploadToken();
  }



  async handleFileUpload() {
    const title = window.current_variant.title; // e.g. "20x30 cm"

    const [width, height] = title
      .replace(" cm", "")    // Remove the unit
      .split("x")            // Split into ["20", "30"]
      .map(Number);          // Convert to numbers

    const variant_ratio = width / height;

    const xhrUpload = this.uppy.getPlugin("XHRUpload");
    xhrUpload.setOptions({
      headers: {
        Authorization: `Bearer ${this.securityToken}`,
        "x-upload-timestamp": this.timestamp
      }
    });

    this.uppy.setMeta({
      desiredRatio: variant_ratio,
      desiredSize: window.current_variant.title,
      uploadToken: this.uploadToken
    });

    this.initializeUploadUI();

    try {
      const result = await this.uppy.upload();

      if (result.failed && result.failed.length > 0) {
        const firstError = result.failed[0].error?.message || result.failed[0].error || "Some files failed to upload.";
        this.showErrorPopup(firstError, true);
      }

      result.successful.forEach(file => {
        const uploadedFile = file.response.body;
        const oldFilename = file.id;
        const newFilename = uploadedFile.original;

    
    
      // For HEIC/HEIF images, process the image using the new method.
      if (file.meta.type === 'image/heic' || file.meta.type === 'image/heif') {
        const cardImg = this.element.querySelector(`[data-file-uppy-id="${oldFilename}"] img`);
        if (cardImg) {
          this.processHeicThumbnail(cardImg, file, uploadedFile.url);
        }
      }


        const fileElement = this.element.querySelector(`[data-file-uppy-id="${oldFilename}"]`);
        if (fileElement) {
          fileElement.setAttribute("data-file-server-id", newFilename);
          fileElement.setAttribute("data-edit-url", uploadedFile.url);
          fileElement.setAttribute("data-variant", window.current_variant.id);
        }
      });

    } catch (err) {
      const errorMessage = err?.message || "An unexpected error occurred during upload.";
      this.showErrorPopup(errorMessage, true); // Catch unexpected upload errors
    }
  }

  async processHeicThumbnail(cardImg, file, uploadedFileUrl) {
    try {
      // Fetch the image blob using the required headers.
      const response = await fetch(uploadedFileUrl, {
        headers: {
          Authorization: `Bearer ${this.securityToken}`,
          "x-upload-timestamp": this.timestamp
        }
      });
      if (!response.ok) {
        throw new Error("Failed to fetch image preview.");
      }
      const blob = await response.blob();
      // Create an object URL for the original blob.
      const originalUrl = URL.createObjectURL(blob);
  
      // Create a temporary image to load the fetched blob.
      const tempImg = new Image();
      tempImg.crossOrigin = 'Anonymous';
      tempImg.src = originalUrl;
      tempImg.onload = () => {
        // Define target dimensions for the compressed preview.
        const targetWidth = 200; // Adjust this value as needed.
        const aspectRatio = tempImg.naturalWidth / tempImg.naturalHeight;
        const targetHeight = targetWidth / aspectRatio;
  
        // Create an off-screen canvas with the target dimensions.
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext('2d');
  
        // Draw the temporary image onto the canvas.
        ctx.drawImage(tempImg, 0, 0, canvas.width, canvas.height);
  
        // Convert the canvas drawing to a compressed blob (JPEG, quality 0.7).
        canvas.toBlob((compressedBlob) => {
          if (compressedBlob) {
            const compressedUrl = URL.createObjectURL(compressedBlob);
            // Call generateThumbnail with the compressed image URL.
            this.generateThumbnail(cardImg, file, compressedUrl);
          } else {
            console.error('Canvas conversion returned null blob.');
          }
          // Free memory by revoking the original URL.
          URL.revokeObjectURL(originalUrl);
        }, 'image/jpeg', 0.7);
      };
  
      tempImg.onerror = (err) => {
        console.error("Error loading temporary image:", err);
      };
    } catch (err) {
      console.error("Error processing HEIC image thumbnail:", err);
    }
  }
  
  

  showErrorPopup(err, closeChilds = false) {
    if (closeChilds == true) {
      const childsPopup = this.element.querySelectorAll('.popup-inside-popup');
      childsPopup.forEach(popup => {
        if (popup.getAttribute('aria-expanded') === 'true') {
          window.globalPopup.closePopup(popup);
        }
      });
    }



    const popup = this.element.querySelector('#modal-pp-error');
    const errMsg = popup.querySelector('.pp__error-msg');
    errMsg.textContent = err;
    window.globalPopup.openPopup(popup, true);
  }


  initializeUploadUI() {
    this.element.setAttribute("aria-uploading", "true");
    const buttonExit = this.element.querySelector('.photo-printer__close');
    if (buttonExit) {
      buttonExit.setAttribute('aria-controls', 'modal-exit');
    }
    const popupUploadMore = this.element.querySelector('#modal-more-imgs');
    // 👇 Check if popup is open and trigger close
    if (popupUploadMore && popupUploadMore.getAttribute('aria-expanded') === 'true') {
      const toggleButton = popupUploadMore.querySelector('[data-action="toggle-popup"]');
      if (toggleButton) {
        toggleButton.click();
      }
    }

    this.globalFill = this.element.querySelector(".photo-print__global-fill");
    this.uploadedCountEl = this.element.querySelector(".pp__uploaded-count");
    this.totalCountEls = this.element.querySelectorAll(".pp__img-count-total");

    this.updateTotalFilesCount(); // Initialize count


    this.uploadedCountEl.textContent = this.uploadedFiles;

    this.globalFill.style.width = `${this.uploadedFiles / this.totalFiles * 100}%`;

    // 👇 Show the upload progress overlay again
    if (this.uploadOverlay) {
      this.uploadOverlay.classList.add('is-visible');
    }

    // 👇 Hide the default footer again
    const defaultStateFooter = this.element.querySelector('.pp__footer-default-state');
    if (defaultStateFooter) {
      defaultStateFooter.setAttribute('aria-hidden', 'true');
    }

    // 👇 Show the uploading state footer
    const uploadStateFooter = this.element.querySelector('.pp__footer-uploade-state');
    if (uploadStateFooter) {
      uploadStateFooter.setAttribute('aria-hidden', 'false');
    }

    this.updateFooterHeight();

  }

  updateTotalFilesCount() {
    this.totalFiles = this.uppy.getFiles().length;
    this.totalCountEls.forEach(el => el.textContent = this.totalFiles);
  }

  updateUploadProgress(file, progress) {
    const card = this.element.querySelector(`[data-file-uppy-id="${file.id}"]`);
    if (card) {
      const percentage = Math.round((progress.bytesUploaded / progress.bytesTotal) * 100);
      const statusElement = card.querySelector(".pp__upload-percentage-value");
      if (percentage === 99) {
        card.querySelector('.pp__img-overlay').classList.add('pp__border');
      }


      statusElement.textContent = `${percentage}%`;
    }
  }

  handleUploadSuccess(file) {
    this.uploadedFiles++;
    this.uploadedCountEl.textContent = this.uploadedFiles;

    const progressPercent = (this.uploadedFiles / this.totalFiles) * 100;
    this.globalFill.style.width = `${progressPercent}%`;

    const card = this.element.querySelector(`[data-file-uppy-id="${file.id}"]`);



    if (card) {
      const statusElement = card.querySelector(".pp__upload-percentage-value");
      const overlayEl = card.querySelector(".pp__img-overlay");
      const checkboxLabel = card.querySelector(".pp__card-checkbox-label"); // Added checkbox label reference

      statusElement.style.opacity = "0";
      overlayEl.style.opacity = "0";

      //  Show the checkbox label when upload is complete
      if (checkboxLabel) checkboxLabel.style.opacity = "1";

    }



    if (this.uploadedFiles === this.totalFiles) {


      const totalInputQuantity = this.element.querySelector(`#id__${window.current_variant.id}`);

      if (totalInputQuantity) {
        totalInputQuantity.dataset.quantity = this.uploadedFiles;
        this.photoQuantity.updateMapQ(`${window.current_variant.id}`, this.uploadedFiles); // Update the map with the new quantity

      }

      this.initSelectboxVariant();
      const uploadTokenInput = this.element.querySelector('#custom_property');



      if (uploadTokenInput) {
        uploadTokenInput.value = this.uploadToken;
      }

      const order_token = localStorage.getItem("security_token");
      const orderTokenInput = this.element.querySelector('#order_token');
      if (orderTokenInput) {
        orderTokenInput.value = order_token;
      }


    }
    setTimeout(() => {
      // Check if all files are uploaded
      if (this.uploadedFiles === this.totalFiles) {
        // Hide the upload state footer
        const uploadStateFooter = this.element.querySelector('.pp__footer-uploade-state');
        if (uploadStateFooter) {
          uploadStateFooter.setAttribute('aria-hidden', 'true');
        }

        // Show the default state footer
        const defaultStateFooter = this.element.querySelector('.pp__footer-default-state');
        if (defaultStateFooter) {
          defaultStateFooter.setAttribute('aria-hidden', 'false');
        }

        if (this.uploadOverlay) {
          this.uploadOverlay.classList.remove('is-visible');
          this.element.setAttribute("aria-uploading", "false");

        }
        // Check if all images are selected and update "Select All"
        this.updateSelectAllCheckbox();
        this.updateFooterHeight();
        new AddToCart(this.element);
      }

    }, 2000); //by design
  }



  initSelectboxVariant(variant) {
    const selectElement = this.element.querySelector('.fjs__variant-select');
    const newValue = variant || window.current_variant?.title;
    if (!selectElement || !newValue) return;

    // Clear current selection for the hidden select
    const options = Array.from(selectElement.options);
    options.forEach(option => option.selected = false);

    // Find and select the matching option by comparing trimmed values
    const matchingOption = options.find(option => option.value.trim() === newValue.trim());
    if (!matchingOption) return;
    matchingOption.selected = true;

    // Update the visible text in the custom selectbox title
    const titleElement = this.element.querySelector('.RevolutionSelectbox--Title');
    if (titleElement) {
      titleElement.textContent = newValue;
    }

    // Update the custom button state by disabling the button that matches newValue
    const buttonItems = this.element.querySelectorAll('.RevolutionSelectbox--Item[data-selectboxid="Size"]');
    buttonItems.forEach(button => {
      if (button.getAttribute('data-value').trim() === newValue.trim()) {
        button.setAttribute('disabled', 'true');
      } else {
        button.removeAttribute('disabled');
      }
    });

    console.log('Updated selectbox variant to:', newValue, selectElement);
  }



  triggerFileInputClick() {
    this.fileInputPlugin.input.click();
  }

  displaySelectedFile(file) {
    // Update inert attributes and reveal overlay
    if (this.photoPrinterStartContent) {
      this.photoPrinterStartContent.setAttribute("inert", "");
    }
    if (this.uploadOverlay) {
      this.uploadOverlay.classList.add('is-visible');
    }
    const uploadedContent = this.element.querySelector(".pp__uploaded-content");
    if (uploadedContent) {
      uploadedContent.removeAttribute("inert");
    }

    // Get the images grid container
    const imgList = this.element.querySelector(".pp__images-grid");
    if (!imgList) return;

    // Clone the image card template
    const clone = document.importNode(this.imgCardTemplate.content, true);

    // Update the variant label if it exists
    const variantLabel = clone.querySelector('.photo-print__card-variant-lbl');
    if (variantLabel) {
      variantLabel.textContent = window.current_variant.title;
    }

    // Obtain the card element and image element in the clone
    const cardEl = clone.querySelector('.photo-print__card-wrapper');
    const imgElement = clone.querySelector(".photo-print__card-image");

    if (imgElement) {
      // Set a temporary placeholder while the thumbnail is loading
      imgElement.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";



      // Listen for the thumbnail generated event for this file
      this.uppy.on('thumbnail:generated', (generatedFile, preview) => {
        if (generatedFile.id === file.id) {
          this.generateThumbnail(imgElement, file, preview);
        }
      });

      // Attach the Uppy file ID to the card element for reference
      if (cardEl) {
        cardEl.dataset.fileUppyId = file.id;
      }
    }

    // Append the cloned template to the images grid
    imgList.appendChild(clone);
  }

  generateThumbnail(imgElement, file, preview) {
    // Set an onload handler to compute the aspect ratio once the thumbnail is loaded
    imgElement.onload = () => {
      const ratio = imgElement.naturalWidth / imgElement.naturalHeight;
      const card = imgElement.closest('.photo-print__card-img-wrapper');
      if (!card) return;

      // Set the CSS variable for aspect ratio
      card.style.setProperty('--aspect-ratio', ratio);

      // Get the overlay ratio from the crop area
      const overlayRatio = card.querySelector('.pp__crop-area')?.style.getPropertyValue('--ar');
      if (!overlayRatio) return;

      const [numStr, denStr] = overlayRatio.split('/');
      const numerator = parseFloat(numStr);
      const denominator = parseFloat(denStr);
      const decimalRatio = numerator / denominator;

      // Determine if the image should be marked as landscape or portrait based on the ratios
      const aspectContainer = imgElement.closest('.AspectRatio');
      if (aspectContainer) {
        if (imgElement.naturalWidth > imgElement.naturalHeight || ratio > decimalRatio) {
          aspectContainer.classList.add('landscape');
        } else {
          aspectContainer.classList.add('portrait');
        }
      }
    };

    // Set the preview source to start loading the generated thumbnail
    imgElement.src = preview;
  }


}

customElements.define("photo-printing", PhotoPrinting);



class FabricJs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

  }

  connectedCallback() {

    this.init();
    this.checkLoaded();
    this.bindEvents();

  }

  init() {
    let selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes)
      selectBoxes.forEach(selectbox => new RevolutionSelectbox(selectbox));



    // Get the current breakpoint.
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.canvas = null;  // We'll initialize Fabric.js canvas here
    this.cropFrame = null;

    //Variables
    this.primaryAccentColor = getComputedStyle(document.documentElement).getPropertyValue('--primary_accent').trim();
    this.backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--background_color').trim();
    this.emtySpaceTopBottomCnv = 64;


    if (this.breakpoint === 'desktop') {
      //Desktop variables
      this.emtySpaceLeftRightCnv = 64;
    }
    else {
      //Mobile variables
      this.emtySpaceLeftRightCnv = 16;
    }


  }

  bindEvents() {
    this.delegateBody.on("edit-img:pressed", this.editImgHandleFabric.bind(this));
    this.delegateElement.on('click', '[data-action="rotate-left"]', this.rotateLeft.bind(this));
    this.delegateElement.on('click', '[data-action="rotate-right"]', this.rotateRight.bind(this));
    this.delegateElement.on('click', '[data-action="apply-landscape"]', this.setCropLandscape.bind(this));
    this.delegateElement.on('click', '[data-action="apply-portrait"]', this.setCropPortrait.bind(this));



    this.delegateElement.on('click', '[data-action="apply-changes"]', this.applyChanges.bind(this));

    this.delegateBody.on('change:size', this.selectboxChange.bind(this));
  }

  checkLoaded() {
    // Check if Fabric.js is loaded, otherwise load it
    if (typeof fabric !== "undefined") {
      this.initializeCanvas();
    } else {
      loadScript(window.theme.fabricScript);
      setTimeout(() => this.checkLoaded(), 100);
    }
  }

  selectboxChange(event) {
    const selectedOption = event.target.querySelector('option[selected]');
    const ratioValue = selectedOption.getAttribute('data-ratio-value');
    this.recalculateCropArea(ratioValue);
    // Update the orientation UI based on the new ratio.
    this.updateOrientationUI();
    this.editImgHandleFabric(false);
  }


  // Initialize the Fabric.js canvas
  initializeCanvas() {
    this.canvasElement = this.element.querySelector('#fabricCanvas');
    if (this.breakpoint === 'desktop') {
      this.canvasWidth = 517; 
    } else {
      this.canvasWidth = window.innerWidth; // Set the canvas width to 100% of the screen width for mobile only
    }

    this.canvas = new fabric.Canvas(this.canvasElement, {
      backgroundColor: this.backgroundColor,
      selection: false  // Disable selection of multiple objects
    });

    this.canvas.preserveObjectStacking = true;

  }

  recalculateCropArea(ratio) {
    this.cropDimensions = {}
    this.cropDimensions.ratio_x = parseInt(ratio.split('/')[0]);
    this.cropDimensions.ratio_y = parseInt(ratio.split('/')[1]);

    let divider = 2;
    if (this.cropDimensions.ratio_x > this.cropDimensions.ratio_y) {
      divider = 1;
    }
    // Landscape: width is the limiting dimension.
    this.cropDimensions.width = (this.canvas.width - this.emtySpaceLeftRightCnv) / divider;
    // Calculate height from width while preserving aspect ratio.
    this.cropDimensions.height = this.cropDimensions.width * (this.cropDimensions.ratio_y / this.cropDimensions.ratio_x);
    if (this.cropDimensions.ratio_x == this.cropDimensions.ratio_y) {
      this.cropDimensions.height = this.cropDimensions.width;
    }

    // Center the crop area on the canvas.
    this.cropDimensions.left = (this.canvas.width - this.cropDimensions.width) / 2;
    this.cropDimensions.top = (this.canvas.height - this.cropDimensions.height) / 2;


    this.cropDimensions.big_dimension = Math.max(this.cropDimensions.width, this.cropDimensions.height);

  }


  createCropArea(ratio) {
    if (ratio) {
      this.recalculateCropArea(ratio);
    } else {
      const ratioValue = this.element.querySelector('.fjs__variant-select option[selected]')?.getAttribute('data-ratio-value');
      this.recalculateCropArea(ratioValue);
    }

    this.cropFrame = new fabric.Rect({
      left: this.cropDimensions.left,
      top: this.cropDimensions.top,
      width: this.cropDimensions.width,
      height: this.cropDimensions.height,
      fill: 'transparent',
      stroke: '#F2F2F0', ///the client's wish is for it not to be white
      strokeWidth: 1,
      selectable: false,
      evented: false
    });

    // Create crop grid inside the crop area (2 vertical and 2 horizontal lines)
    this.createCropGrid(this.cropFrame);
  }

  createCropGrid(cropFrame) {

    this.cutout = new fabric.Rect({
      left: this.cropDimensions.left,
      top: this.cropDimensions.top,
      width: this.cropDimensions.width,
      height: this.cropDimensions.height,
      fill: 'black', 
      globalCompositeOperation: 'destination-out',
      selectable: false,
      evented: false
    });

    const lineOption = {
      stroke: '#F2F2F0',   //the client's wish is for it not to be white
      strokeWidth: 1,
      selectable: false,  // Make the lines non-selectable
      evented: false      // Prevent the lines from triggering events
    };

    // Create vertical lines (2 lines)
    const verticalLines = [
      new fabric.Line([this.cropDimensions.left + this.cropDimensions.width / 3, this.cropDimensions.top, this.cropDimensions.left + this.cropDimensions.width / 3, this.cropDimensions.top + this.cropDimensions.height], lineOption),
      new fabric.Line([this.cropDimensions.left + (this.cropDimensions.width * 2) / 3, this.cropDimensions.top, this.cropDimensions.left + (this.cropDimensions.width * 2) / 3, this.cropDimensions.top + this.cropDimensions.height], lineOption)
    ];

    // Create horizontal lines (2 lines)
    const horizontalLines = [
      new fabric.Line([this.cropDimensions.left, this.cropDimensions.top + this.cropDimensions.height / 3, this.cropDimensions.left + this.cropDimensions.width, this.cropDimensions.top + this.cropDimensions.height / 3], lineOption),
      new fabric.Line([this.cropDimensions.left, this.cropDimensions.top + (this.cropDimensions.height * 2) / 3, this.cropDimensions.left + this.cropDimensions.width, this.cropDimensions.top + (this.cropDimensions.height * 2) / 3], lineOption)
    ];

    const groupObject = [cropFrame, ...verticalLines, ...horizontalLines];

    // Group the grid lines into a single object
    this.gridGroup = new fabric.Group(groupObject, {
      selectable: false,  // Optional: prevent user from selecting the grid
      evented: false      // Optional: ignore events on the grid
    });



    // Add the grid lines to canvas
    this.canvas.add(this.gridGroup);


    this.canvas.bringObjectToFront(this.gridGroup)


  }



  // Call this method after you add a new object to the canvas (such as an image)
  refreshGridLines() {
    // Clear previous grid lines and re-add them after an image is added
    this.canvas.getObjects().forEach(obj => {
      if (obj instanceof fabric.Line) {
        this.canvas.remove(obj);
      }
    });


  }


  applyChanges(event) {
    const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
    const closeBtn = this.element.querySelector('#modal-edit-img .fjs__close-btn');
    if (!selectedOption) {
      console.warn('No selected option found');
      return;
    }

    const variantId = selectedOption.getAttribute('data-variant-id');
    const variantValue = selectedOption.value;
    const imgCardId = event.target.dataset.imgCardId;

    // Determine which orientation is selected.
    const orientation = this.element.querySelector('[data-action="apply-landscape"]').classList.contains('selected')
      ? 'landscape'
      : 'portrait';

    // Save the orientation info on the card element.
    const card = document.body.querySelector(`[data-file-uppy-id="${imgCardId}"]`);
    if (card) {
      card.setAttribute("data-orientation", orientation);
    }


    this.element.dispatchEvent(
      new CustomEvent("update:main-atc", {
        bubbles: true,
        detail: {
          eventName: "updata-main-atc",
          variantId: variantId,
          variantValue: variantValue,
          cardId: imgCardId
        },
      })
    );

    //Apply crop

    this.cropImageHighQuality(variantValue);


    //close popup
    if (closeBtn) {
      closeBtn.click();
    }
  }

  editImgHandleFabric(event) {
    // Load selected image to Fabric.js canvas
    const imgUrl = this.element.querySelector('.fabric-js__popup')?.getAttribute('data-img-url');
    let imgCardId = null;
    if (event != false) {
      imgCardId = event.detail.imgCardId;
    }

    const applyBtn = this.element.querySelector('[data-action="apply-changes"]');
    if (!imgUrl) {
      console.error('No image URL found');
      return;
    }
    if (applyBtn && imgCardId) {
      applyBtn.setAttribute('data-img-card-id', imgCardId);
    }




    const imgElement = new Image();
    // Set CORS attribute to allow cross-origin requests
    imgElement.crossOrigin = 'Anonymous'; // This is required for CORS-enabled images

    imgElement.src = imgUrl;
    this.canvas.clear();  // Clear previous objects
    imgElement.onload = () => {
      this.originalImg = imgElement;

      const imgWidth = imgElement.width;
      const imgHeight = imgElement.height;
      const canvasContainer = this.element.querySelector('.fabric-js__img-content');


      if (this.breakpoint === 'desktop') {
        this.canvasHeight = 517;

      } else {
        this.canvasWidth = canvasContainer.offsetWidth;
        // Set height based on image orientation
        if (imgHeight > imgWidth) {
          this.canvasHeight = 439;
        } else if (imgHeight == imgWidth) {
          this.canvasHeight = 343;
        } else {
          this.canvasHeight = 298;
        }


      }

      // Initialize Fabric.js canvas with updated size
      this.canvas.setWidth(this.canvasWidth);
      this.canvas.setHeight(this.canvasHeight);


      this.createCropArea();
      this.updateOverlayGroup();  // if you have an overlay updater as discussed

      // Check if the card has a saved orientation.
      if (imgCardId) {
        const card = document.querySelector(`[data-file-server-id="${imgCardId}"]`);
        if (card && card.getAttribute("data-orientation")) {
          const storedOrientation = card.getAttribute("data-orientation");
          if (storedOrientation === "landscape") {
            this.setCropLandscape();
          } else {
            this.setCropPortrait();
          }
        } else {
          // Otherwise, update the UI based on the currently selected ratio.
          this.updateOrientationUI();
        }
      }


      const rotateIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIHRyYW5zZm9ybT0icm90YXRlKC05MCAwLjUgMjQpIiBmaWxsPSIjOEVBQkMyIi8+CjxwYXRoIGQ9Ik0xMC4xNzcyIDE1LjRMMTAuMTc3MiAxNi42MTRDOS4xNzczOCAxNi4wNzY5IDguMzgwOTcgMTUuMjA4NSA3LjkxNTU1IDE0LjE0NzlDNy40NTAxMiAxMy4wODc0IDcuMzQyNjMgMTEuODk2IDcuNjEwMjkgMTAuNzY0N0M3Ljg3Nzk1IDkuNjMzNSA4LjUwNTI3IDguNjI3ODcgOS4zOTE3MyA3LjkwODk5QzEwLjI3ODIgNy4xOTAxIDExLjM3MjUgNi43OTk1OCAxMi40OTkyIDYuOEwxMi40OTkyIDZDMTEuMjIxMSA2LjAwMTE3IDkuOTc5MSA2LjQzODI3IDguOTY1ODggNy4yNDM0OEM3Ljk1MjY1IDguMDQ4NyA3LjIyNDg2IDkuMTc3MDEgNi44OTU0IDEwLjQ1MzRDNi41NjU5NCAxMS43Mjk3IDYuNjUzMjQgMTMuMDgyOCA3LjE0Mzc1IDE0LjMwMjdDNy42MzQyNiAxNS41MjI1IDguNTAwNTYgMTYuNTQxIDkuNjA4MjYgMTcuMkw4LjQzNTYyIDE3LjJMOC40MzU2MiAxOEwxMC45NTEyIDE4TDEwLjk1MTIgMTUuNEwxMC4xNzcyIDE1LjRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTQuODIyMSA4LjZMMTQuODIyMSA3LjM4NkMxNS44MjE4IDcuOTIzMDggMTYuNjE4MiA4Ljc5MTQ4IDE3LjA4MzcgOS44NTIwNkMxNy41NDkxIDEwLjkxMjYgMTcuNjU2NiAxMi4xMDQgMTcuMzg4OSAxMy4yMzUzQzE3LjEyMTMgMTQuMzY2NSAxNi40OTQgMTUuMzcyMSAxNS42MDc1IDE2LjA5MUMxNC43MjEgMTYuODA5OSAxMy42MjY4IDE3LjIwMDQgMTIuNSAxNy4yTDEyLjUgMThDMTMuNzc4MSAxNy45OTg4IDE1LjAyMDEgMTcuNTYxNyAxNi4wMzMzIDE2Ljc1NjVDMTcuMDQ2NiAxNS45NTEzIDE3Ljc3NDQgMTQuODIzIDE4LjEwMzggMTMuNTQ2NkMxOC40MzMzIDEyLjI3MDMgMTguMzQ2IDEwLjkxNzIgMTcuODU1NSA5LjY5NzMzQzE3LjM2NSA4LjQ3NzQ4IDE2LjQ5ODcgNy40NTkwMyAxNS4zOTEgNi44TDE2LjU2MzYgNi44TDE2LjU2MzYgNkwxNC4wNDggNkwxNC4wNDggOC42TDE0LjgyMjEgOC42WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
      this.imgRotate = document.createElement('img');
      this.imgRotate.src = rotateIcon;

      this.imgRotate.onload = () => {

        // Use the `new` keyword to create a fabric.Image instance
        this.fabricImg = new fabric.Image(imgElement, {
          left: this.emtySpaceLeftRightCnv, // Center the image on the canvas
          top: this.emtySpaceTopBottomCnv,
          hasRotatingPoint: false,  // Allow rotation as well (optional)
          hasControls: true,  // Show resizing controls
          selectable: true,  // Allow the image to be selected
          borderColor: this.primaryAccentColor,  // Color of the border around the image
          cornerColor: this.primaryAccentColor,  // Custom color for the control points (resize dots)
          cornerSize: 18,      // Size of the control dots
          transparentCorners: false, // Disable transparent corners (make them solid color)
          cornerStyle: 'circle', // Change the shape of the resize control dots to circles
          scaleX: 1,
          scaleY: 1,
          centeredScaling: true,
          objectCaching: false
        }

        );

        //Hide the middle control points
        this.fabricImg.setControlsVisibility({
          'mt': false, 'mb': false, 'ml': false, 'mr': false, 'mtr': false
        })

        this.fabricImg.controls.rotating = new fabric.Control({
          x: 0,
          y: -0.5,
          offsetY: -25,
          cursorStyle: 'crosshair',
          actionHandler: fabric.controlsUtils.rotationWithSnapping,
          actionName: 'rotate',
          render: this.renderIcon.bind(this),
          cornerSize: 24,
          withConnection: true
        });



        const overlay = new fabric.Rect({
          left: 0,
          top: 0,
          width: this.canvas.width,
          height: this.canvas.height,
          fill: 'rgba(255,255,255,0.5)',  // Semi-transparent overlay
          selectable: false,
          evented: false  // Disable interaction with this overlay
        });



        this.overlayGroup = new fabric.Group([overlay, this.cutout], {
          selectable: false,
          evented: false
        });

        this.renderingImage();

        this.updateHeightOfPopup();

      };



      imgElement.onerror = () => {
        console.error('Failed to load image');
      };
    }


  }

  updateHeightOfPopup() {

    const container = this.element.querySelector('#modal-edit-img');
    const contentWrapper = container.querySelector('.fabric-js__edit-content-wrapper[data-scrollable]');
    if (!container || !contentWrapper) return;

    // Let the content flow naturally by clearing any inline height
    container.style.height = 'fit-content';

    // Force reflow (optional but sometimes helpful)
    const naturalHeight = contentWrapper.scrollHeight + 67;

    // Compare to the max height set in CSS
    const maxHeight = parseFloat(
      getComputedStyle(container).getPropertyValue('--viewport-height')
    ) - 52;

    console.log('naturalHeight:', naturalHeight);
    console.log('viewport-height var:',
      getComputedStyle(container).getPropertyValue('--viewport-height')
    );
    console.log('parsed maxHeight:', maxHeight);
    // If the content is bigger than our maximum, clamp container’s height:
    if (naturalHeight > maxHeight) {
      container.style.height = `${maxHeight}px`;
    } else {
      container.style.height = `${naturalHeight}px`;  // or just fit-content
    }


  }



  cropImageHighQuality(size) {
    if (!this.originalImg || !this.fabricImg) {
      console.error("Original or working image not available");
      return;
    }
    
    // 1. Compute the multiplier:
    // Get the displayed width of your fabric image (in the preview canvas)
    const displayedWidth = this.fabricImg.getScaledWidth();
    // multiplier = how many times larger the original is compared to the preview
    const multiplier = this.originalImg.naturalWidth / displayedWidth;
    
    // 2. Compute the full-resolution crop dimensions:
    // (cropDimensions is defined in canvas coordinates)
    const cropFullWidth = this.cropDimensions.width * multiplier;
    const cropFullHeight = this.cropDimensions.height * multiplier;
    
    // 3. Determine the crop area offset relative to the image
    // (fabricImg.left is the image’s position on the canvas)
    const cropOffsetX = this.cropDimensions.left - this.fabricImg.left;
    const cropOffsetY = this.cropDimensions.top - this.fabricImg.top;
    // Convert to full-resolution coordinates
    const fullCropOffsetX = cropOffsetX * multiplier;
    const fullCropOffsetY = cropOffsetY * multiplier;
    
    // 4. Create an off-screen canvas element sized to the crop area (in full resolution)
    const offscreenCanvasEl = document.createElement("canvas");
    offscreenCanvasEl.width = cropFullWidth;
    offscreenCanvasEl.height = cropFullHeight;
    
    // Create an off-screen Fabric canvas on that element.
    const offscreenFabricCanvas = new fabric.Canvas(offscreenCanvasEl, {
      backgroundColor: 'white'  // fill with white to avoid transparent areas
    });
    
    // 5. Create a new Fabric image from the original high‑quality image.
    // We want to render it with full resolution. Assuming that when the original fabric image was created,
    // its "width" property was set to the original image width.
    const fullScale = this.originalImg.naturalWidth / this.fabricImg.width;  // effective scale factor
    
    const newImage = new fabric.Image(this.originalImg, {
      // Set the image to full resolution by using fullScale.
      scaleX: fullScale,
      scaleY: fullScale,
      angle: this.fabricImg.angle,   // copy rotation
      originX: 'left',
      originY: 'top',
      selectable: false,
      evented: false
    });
    
    // 6. Position the new image so that the region corresponding to your crop area is at (0,0)
    //    of the off-screen canvas.
    // The crop area offset relative to the preview fabric image, multiplied up to full res:
    newImage.set({
      left: -fullCropOffsetX,
      top: -fullCropOffsetY
    });
    
    // Add the image to the offscreen Fabric canvas.
    offscreenFabricCanvas.add(newImage);
    offscreenFabricCanvas.renderAll();
    
    // 7. Export the off-screen canvas as a dataURL (full-resolution cropped image with white background)
    const dataUrl = offscreenCanvasEl.toDataURL("image/png");
    this.saveImageToServer(dataUrl, size);
    
    // Clean up
    offscreenFabricCanvas.dispose();
  }
  
  
  



  renderingImage() {
    if (this.cropDimensions.ratio_x >= this.cropDimensions.ratio_y) {
      // Landscape crop grid: force image width.
      this.fabricImg.scaleToWidth(this.cropDimensions.big_dimension);
    } else {
      // Portrait crop grid: force image height.
      this.fabricImg.scaleToHeight(this.cropDimensions.big_dimension);
    }


    // Optional: Center the image over the crop area.
    // You can compute the new dimensions of the scaled image:
    const newImgWidth = this.fabricImg.getScaledWidth();
    const newImgHeight = this.fabricImg.getScaledHeight();

    // Position so that the image is centered relative to the crop grid.
    const offsetX = this.cropDimensions.left + (this.cropDimensions.width - newImgWidth) / 2;
    const offsetY = this.cropDimensions.top + (this.cropDimensions.height - newImgHeight) / 2;
    this.fabricImg.set({ left: offsetX, top: offsetY });

    this.canvas.add(this.overlayGroup)


    this.canvas.setActiveObject(this.fabricImg);
    this.fabricImg.setCoords();

    this.canvas.add(this.fabricImg);
    this.canvas.bringObjectToFront(this.overlayGroup)
    this.canvas.bringObjectToFront(this.gridGroup);
    this.canvas.renderAll();
  }


  async dataURLToBlob(dataURL) {
    const [header, base64] = dataURL.split(',');
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }

    return new Blob([array], { type: mime });
  }

  async saveImageToServer(dataUrl, size) {
    const blob = await this.dataURLToBlob(dataUrl);
    const formData = new FormData();
    formData.append("file", blob, "edited-image.png");

    const fileName = this.element.querySelector('#modal-edit-img')?.dataset.name;
    await apiService.saveEditedImage(size, fileName, formData);


    this.generateThumbnail(blob, 500, fileName);

  }

  generateThumbnail(blob, thumbnailWidth = 500, filename) {
    return new Promise((resolve, reject) => {
      // Create an object URL for the blob
      const objectUrl = URL.createObjectURL(blob);
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        // Calculate the aspect ratio and the corresponding thumbnail height
        const aspectRatio = img.width / img.height;
        const thumbnailHeight = thumbnailWidth / aspectRatio;

        // Create an off-screen canvas with thumbnail dimensions preserving aspect ratio
        const canvas = document.createElement('canvas');
        canvas.width = thumbnailWidth;
        canvas.height = thumbnailHeight;
        const ctx = canvas.getContext('2d');

        // Draw the image scaled to the thumbnail dimensions
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Convert the canvas drawing to a blob (e.g., PNG)
        canvas.toBlob((thumbnailBlob) => {
          // Revoke the object URL to free up memory 
          URL.revokeObjectURL(objectUrl);
          if (thumbnailBlob) {
            resolve(thumbnailBlob);
          } else {
            reject(new Error('Thumbnail generation failed.'));
          }
        }, 'image/png');
      };

      img.onerror = (err) => {
        // Revoke the object URL even if there's an error
        URL.revokeObjectURL(objectUrl);
        reject(err);
      };

      const card = document.querySelector(`[data-file-server-id="${filename}"]`);
      if (!card) return;
      card.querySelector('img').src = objectUrl;
      card.querySelector('.crop__area')?.remove();
      card.querySelector('.pp__edited').classList.add('is-visible');
    });
  }



  renderIcon(ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize || 24;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(this.imgRotate, -size / 2, -size / 2, size, size);
    ctx.restore();
  }

  // Rotate image left
  rotateLeft() {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      activeObject.rotate(activeObject.angle - 90);


      // 💡 Force Fabric to recalculate control positions
      activeObject.setCoords();
      this.canvas.requestRenderAll();
    }
  }

  // Rotate image right
  rotateRight() {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      activeObject.rotate(activeObject.angle + 90);


      // 💡 Force Fabric to recalculate control positions
      activeObject.setCoords();
      this.canvas.requestRenderAll();
    }
  }


  updateOverlayGroup() {
    // Remove the old overlay group, if present.
    if (this.overlayGroup) {
      this.canvas.remove(this.overlayGroup);
    }
    // Create a full-canvas overlay.
    const overlay = new fabric.Rect({
      left: 0,
      top: 0,
      width: this.canvas.width,
      height: this.canvas.height,
      fill: 'rgba(255,255,255,0.5)', // Semi-transparent overlay
      selectable: false,
      evented: false
    });
    // Create a new cutout using the updated crop dimensions.
    this.cutout = new fabric.Rect({
      left: this.cropDimensions.left,
      top: this.cropDimensions.top,
      width: this.cropDimensions.width,
      height: this.cropDimensions.height,
      fill: 'black',
      globalCompositeOperation: 'destination-out',
      selectable: false,
      evented: false
    });
    // Group them so that the cutout creates the transparent "window".
    this.overlayGroup = new fabric.Group([overlay, this.cutout], {
      selectable: false,
      evented: false
    });
    // Add the updated overlay group to the canvas.
    this.canvas.add(this.overlayGroup);
    this.canvas.bringObjectToFront(this.overlayGroup);
  }

  updateOrientationUI() {
    const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
    if (!selectedOption) return;

    // Since all values include '/', split them
    const ratioValue = selectedOption.getAttribute('data-ratio-value');
    const [num, den] = ratioValue.split('/').map(Number);

    // Get the button wrapper element
    const btnWrapper = this.element.querySelector('.fjs__btns-wrapper');

    // Check if both numbers are equal (square ratio)
    if (num === den) {
      btnWrapper.classList.add('hidden');
    } else {
      btnWrapper.classList.remove('hidden');

      // Optionally update individual button states based on the orientation
      const btnLandscape = this.element.querySelector('[data-action="apply-landscape"]');
      const btnPortrait = this.element.querySelector('[data-action="apply-portrait"]');

      // If the ratio indicates landscape
      if (num > den) {
        btnLandscape.classList.add('selected');
        btnPortrait.classList.remove('selected');
      } else {
        // For portrait
        btnLandscape.classList.remove('selected');
        btnPortrait.classList.add('selected');
      }
    }
  }



  setCropLandscape() {
    const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
    if (!selectedOption) return;
    let ratio = selectedOption.getAttribute('data-ratio-value'); // e.g., "9/13"
    let [num, den] = ratio.split('/').map(Number);
    // For landscape, ensure ratio > 1; if not, swap.
    if (num < den) {
      ratio = `${den}/${num}`;
    }
    // Remove the old grid.
    if (this.gridGroup) {
      this.canvas.remove(this.gridGroup);
    }
    // Recreate crop grid with the new ratio.
    this.createCropArea(ratio);
    // Update the overlay to match the new crop area.
    this.updateOverlayGroup();
    this.canvas.requestRenderAll();
    // Optionally, re-render the image if loaded.
    if (this.fabricImg) {
      this.renderingImage();
    }
    // Update UI state.
    this.element.querySelector('[data-action="apply-landscape"]').classList.add('selected');
    this.element.querySelector('[data-action="apply-portrait"]').classList.remove('selected');
  }

  setCropPortrait() {
    const selectedOption = this.element.querySelector('select.fjs__variant-select option[selected]');
    if (!selectedOption) return;
    let ratio = selectedOption.getAttribute('data-ratio-value'); // e.g., "13/9"
    let [num, den] = ratio.split('/').map(Number);
    // For portrait, ensure ratio < 1; if not, swap.
    if (num > den) {
      ratio = `${den}/${num}`;
    }
    // Remove the old grid.
    if (this.gridGroup) {
      this.canvas.remove(this.gridGroup);
    }
    // Recreate crop grid with the new ratio.
    this.createCropArea(ratio);
    // Update the overlay to match the new crop area.
    this.updateOverlayGroup();
    this.canvas.requestRenderAll();
    // Optionally, re-render the image if loaded.
    if (this.fabricImg) {
      this.renderingImage();
    }
    // Update UI state.
    this.element.querySelector('[data-action="apply-landscape"]').classList.remove('selected');
    this.element.querySelector('[data-action="apply-portrait"]').classList.add('selected');
  }


}

customElements.define('fabric-js', FabricJs);

